const FALLBACK_AVATAR = "/images/user/owner.jpg";
const FALLBACK_API_ORIGIN = "http://127.0.0.1:8000";

const getApiOrigin = (): string =>
    (import.meta.env.VITE_API_BASE || FALLBACK_API_ORIGIN).trim().replace(/\/+$/, '').replace(/\/api$/, '');

export const getUserImageUrl = (image: unknown): string => {
    const source =
        typeof image === 'object' && image !== null
            ? (image as any).path || (image as any).url || (image as any).avatar
            : image;

    if (!source || typeof source !== 'string') {
        return FALLBACK_AVATAR;
    }

    if (source.startsWith('http')) {
        return source;
    }

    return `${getApiOrigin()}/${source.replace(/^\/+/, '')}`;
};

export const normalizeAuthUser = (userData: any = {}) => {
    const image = userData.image ?? userData.avatar ?? null;

    return {
        id: userData.user_id || userData.id,
        username: userData.username,
        name: userData.name || [userData.first_name, userData.last_name].filter(Boolean).join(' ') || 'User',
        role: Array.isArray(userData.role) ? userData.role[0] : userData.role,
        email: userData.email,
        avatar: image,
        image,
        image_id: userData.image_id ?? userData.avatar_id,
    };
};
